<template>
  <div class="container">
    <div class="banner w100 d-flex position-relative">
      <div class="banner__text w100">
        <div class="banner__title text-medium">Цікаво подивитися, чи є ти або друзі-колеги <br> серед 4700 щасливчиків?</div>
        <div class="banner__description">Переходь та шукай
        </div>
        <router-link to="/winners" class="button button-success banner__button text-center">До списку номінантів</router-link>
      </div>
      <img src="./../assets/images/banners/people.png" class="banner__img position-absolute" alt="People">
    </div>
  </div>
</template>

<script>
export default {
  name: 'BannerPeople'
}
</script>

<style scoped lang="scss">
@use 'sass:math';
@import '../assets/styles/parts/variables';
@import '../assets/styles/parts/mixins';
.container {
  @media (max-width: 1023px) {
    padding: sm(136) 0;
  }
  @include _1024 {
    padding-top: sl(168);
    padding-bottom: sl(179);
  }
  @include _1920 {
    padding-top: 168px;
    padding-bottom: 179px;
  }
}
.banner {
  background: rgba(36, 53, 53, 0.04);
  border: 1px solid $border-gray;
  border-radius: sm(24);
  padding: sm(40) sm(25) sm(240);
  min-height: sm(462);
  @include _1024 {
    border-radius: sl(24);
    padding: sl(64) sl(64) sl(67);
    min-height: sl(369);
  }
  @include _1920 {
    padding: 64px 64px 67px;
    min-height: 369px;
    border-radius: 24px;
  }

  &__title {
    font-size: sm(18);
    line-height: math.div(38.4, 32);
    padding-bottom: sm(16);
    @include _1024 {
      font-size: sl(32);
      padding-bottom: sl(24);
    }
    @include _1920 {
      font-size: 32px;
      padding-bottom: 24px;
    }
  }
  &__description {
    font-size: sm(14);
    line-height: math.div(33.6, 24);
    padding-bottom: sm(24);
    @include _1024 {
      font-size: sl(24);
      padding-bottom: sl(32);
    }
    @include _1920 {
      font-size: 24px;
      padding-bottom: 32px;
    }
  }
  &__img {
    width: sm(185);
    height: sm(208);
    object-fit: contain;
    object-position: center;
    bottom: 0;
    right: 50%;
    transform: translateX(50%);
    @include _1024 {
      right: sl(169);
      width: sl(373);
      height: sl(408);
      transform: translateX(0);
    }
    @include _1920 {
      width: 373px;
      height: 408px;
      right: 169px;
    }
  }
  &__button {
    padding: sm(14) sl(32);
    line-height: 1;
    font-size: sm(14);
    border-radius: sm(8);
    display: block;
    @include _1024 {
      padding: sl(24) sl(32);
      font-size: sl(24);
      border-radius: sl(8);
      display: inline-block;
    }
    @include _1920 {
      padding: 24px 32px;
      font-size: 24px;
      border-radius: 8px;
    }
  }
}
</style>
